export default __webpack_public_path__ + "static/media/Apple (3).77d62b7c.jpg";